var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center text-error leading-7"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('popupCard.bannedCard.desc'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }